import React, { useEffect, useState } from "react";
import "../../../Components/Dashboard/EmpDashboard/Dashboard.css";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { BiHomeAlt } from "react-icons/bi";
import { FaArrowUp } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaBriefcase } from "react-icons/fa";
import { HiUsers } from "react-icons/hi2";
import { FaGlobe } from "react-icons/fa";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  Token,
  userId,
} from "../../../Utils/utils";
import axios from "axios";
import userimg from "../../../Assets/Images/user6.png";
import { toast } from "react-toastify";
import Loader from "../../loader/loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { LiaUserClockSolid } from "react-icons/lia";
import { TiCalendarOutline } from "react-icons/ti";
import { LuFileAxis3D } from "react-icons/lu";
import { MdAvTimer } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { MdOutlineModeEdit } from "react-icons/md";
import { Modal } from "react-bootstrap";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";

const EmpDashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [userTodaysAttendance, setUserTodaysAttendance] = useState();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [yesterdayAttendanceData, setYesterdayAttendanceData] = useState([]);
  const [monthlyLateLeaves, setMonthlyLateLeaves] = useState([]);
  // const [Totalleaves, setTotalleaves] = useState([]);
  const [Thisyeardata, setThisyeardata] = useState("");
  console.log(Thisyeardata,"Thisyeardata");
  const [loading, setLoading] = useState(false);
  const [lateleaves, setlateleaves] = useState("");
  const [monthlyShortLeaves, setMonthlyShortLeaves] = useState([]);
  const [Announceentdata, setAnnounceentdata] = useState([]);
  const [LeaveRequestdata, setLeaveRequestdata] = useState([]);
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [leaveRequest, setLeaveRequest] = useState();
  console.log(leaveRequest,"leaveRequestleaveRequest");
  const [findUserId,setFindUserId]=useState()
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [showModalNew, setShowModalNew] = useState(false);
  const [deleteLeave, setDeleteLeave] = useState({
    IdDelete: "",
  });

  const LoginToken = GetToken();
  const addAMPM = (timeString) => {
    const time = new Date(`1970-01-01T${timeString}`);
    if (isNaN(time.getTime())) {
      return "";
    }
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    return time.toLocaleTimeString("en-US", options);
  };
  const timeString = yesterdayAttendanceData?.OutTime || "";
  const formattedTime = addAMPM(timeString);
  const timeINString = userTodaysAttendance?.InTime || "";
  const formattedINTime = addAMPM(timeINString);

  const TodaysAttendance = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetTodayAttendanceEmployee`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setUserTodaysAttendance(data);
        setLoading(false);
      })
      .catch(() => {});
  };
  useEffect(() => {
    TodaysAttendance();
  }, []);

  const userTime = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetAttendanceByUser`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
      })
      .catch(() => {});
  };
  useEffect(() => {
    userTime();
  }, []);

  // GetYesterdayAttendance
  const YesterdayAttendance = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetYesterdayAttendance`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setYesterdayAttendanceData(data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    YesterdayAttendance();
  }, []);

  // GetMonthlyShortLeave Api
  const GetMonthlyShortLeave = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetMonthlyShortLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);

        setMonthlyShortLeaves(data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    GetMonthlyShortLeave();
  }, []);

  const [deleteClickable, setDeleteClickable] = useState("");
  const handleLeaveDelete = (item) => {
    setDeleteClickable(item);
    setShowModalNew(true);
  };
  const handleCloseModal = () => {
    setShowModalNew(false);
    setDeleteLeave({
      IdDelete: "",
    });
    setErrorLeaveType(false);
  };
  const handleAttendanceSearch = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
      // data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveRequest(data);
        // const findIds = data.map((item)=>{return(item.UserId)})
        // console.log(findIds,"findIds1111");
        // setFindUserId(findIds)
        setLeaveRequestDuplicate(data);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  useEffect(() => {
    handleAttendanceSearch();
  }, []);

  const modalValidate = () => {
    if (deleteLeave?.IdDelete?.trim() === "") {
      toast.error("Please enter Reason");
      return false;
    }
    return true;
  };
  const handleDeleteLeave = (e) => {
    if (!modalValidate()) return;
    setLoading(true);
    const data = {};
    data.Id = deleteClickable?.Id;
    data.CancelReason = deleteLeave?.IdDelete;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/CancelLeave`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          handleCloseModal();
          handleAttendanceSearch();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const EMPLeaveRequests = () => {
    const LoginToken = GetToken();
    const data = {};
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
      // data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveRequestdata(data);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    EMPLeaveRequests();
  }, []);

  const CurrentYearLeaves = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
        
      },
      url: `${Apiurl()}/Attendence/CurrentYearLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = response?.data?.data;
        setThisyeardata(data);
      })
      .catch((error) => {
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  useEffect(() => {
    CurrentYearLeaves();
  }, []);
  const Lateleaves = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetMonthlyLateLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = response?.data?.data;
        setlateleaves(data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    Lateleaves();
  }, []);
  const Getannouncement = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Announcement/GetAnnouncements`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setAnnounceentdata(data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    Getannouncement();
  }, []);

  useEffect(() => {
    Getannouncement();
  }, []);
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const GetProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        console.log(data,"datadata");
        // setProfileData(data);
        setFindUserId(data.UserId)
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetProfile();
  }, [])
  // allUser Leave data ...
  const addPreviousData = {
    leavesData: [
      { Totalleavesdata: "11.75", UserId: "254" },
      { Totalleavesdata: "10.25", UserId: "255" },
      { Totalleavesdata: "13.5",  UserId: "274" },
      { Totalleavesdata: "10",    UserId: "257" },
      { Totalleavesdata: "6.5",   UserId: "258" },
      { Totalleavesdata: "9.75",  UserId: "259" },
      { Totalleavesdata: "16.5",  UserId: "260" },
      { Totalleavesdata: "3.75",  UserId: "261" },
      { Totalleavesdata: "7.25",  UserId: "275" },
      { Totalleavesdata: "8",     UserId: "262" },
      { Totalleavesdata: "12.75", UserId: "263" },
      { Totalleavesdata: "12.75", UserId: "264" }, 
      { Totalleavesdata: "6.5",   UserId: "265" },
      { Totalleavesdata: "3.75",  UserId: "266" },
      { Totalleavesdata: "18.5",  UserId: "267" },
      { Totalleavesdata: "9",     UserId: "268" },
      { Totalleavesdata: "9.25",  UserId: "273" },
      { Totalleavesdata: "0",     UserId: "272" },
    ]
  }
  console.log(addPreviousData,"addPreviousDataaddPreviousData");
  const [totalLeaves, setTotalLeaves] = useState(null);
  const [CombinData, setCombinData] = useState(null);
console.log(CombinData,"CombinDataCombinData");
 console.log(totalLeaves,"totalLeaves");
 
  useEffect(() => {
    const matchedData = addPreviousData.leavesData.find(
      (item) => item?.UserId == findUserId
    );
    console.log(findUserId,"findUserId");
    console.log(matchedData,"matchedData");
    if (matchedData) {
      setTotalLeaves(matchedData.Totalleavesdata);
    } else {
      setTotalLeaves(null);
    }
  }, [findUserId]);
  
  useEffect(() => {
    if (totalLeaves != null && Thisyeardata != null) {
      const numericTotalLeaves = Number(totalLeaves);
      const numericThisyeardata = Number(Thisyeardata);
      const data = numericTotalLeaves + numericThisyeardata;
      setCombinData(data);
    }
  }, [totalLeaves, Thisyeardata]);
  
  
  
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <section
            className={
              showSidebar
                ? "dashboard-main-container"
                : "dashboard-main-container-new"
            }
          >
            <div className="all-icons">
              <div>
                <p className="DASHBOARD-MAIN-HEADING">Dashboard </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p>Home </p>
                <MdKeyboardArrowRight />
                <p>Dashboard </p>
              </div>
            </div>
            <div>
              <div className="dashboard-allcards-flex-container">
                {/*FIRST-CARD/ */}
                <div className="dashboard-card-first-one">
                  <div className="dashboard-img-icon">
                    <LiaUserClockSolid />
                  </div>
                  <p className="dashboard-1st-card-heading">
                    Today's Log in time
                  </p>
                  <p className="dashboard-number-heading">
                    {/* {userTodaysAttendance?.InTime ? userTodaysAttendance?.InTime : "-"} */}
                    {formattedINTime ? formattedINTime.toLocaleString() : "-"}
                  </p>
                </div>
                <div className="dashboard-card">
                  <div className="dashboard-img-icon">
                    <MdAvTimer />
                  </div>
                  <p className="dashboard-1st-card-heading">
                    Yesterday’s Log out time
                  </p>
                  <p className="dashboard-number-heading">
                    {formattedTime ? formattedTime.toLocaleString() : "-"}
                  </p>
                </div>
                {/*SECOND--CARD/ */}
                <div className="dashboard-SECOND-card">
                  <div className="dashboard-img-icon">
                    <LuFileAxis3D />
                  </div>
                  <p className="dashboard-1st-card-heading">
                    Leaves since 1 Jan
                      {/* Total no. of leaves from 1st Jan till current date */}
                  </p>
                  <p className="dashboard-number-heading">
                    {/* {Thisyeardata || "-"} */}
                    {CombinData }
                  </p>
                </div>
                {/*SECOND- LAST-CARD/ */}
                <div className="dashboard-card-second-last">
                  <div className="dashboard-img-icon">
                    <TiCalendarOutline />
                  </div>
                  <p className="dashboard-1st-card-heading">
                    Short Leaves this month
                  </p>
                  <p className="dashboard-number-heading">
                    {monthlyShortLeaves ? monthlyShortLeaves?.Result : "-"}
                  </p>

                  <div className="dashboard-card-img-second-last"></div>
                </div>
              </div>
            </div>
            <div className="emp-dashboard-cards">
              {/* Leave Requests table  */}
              <div className="emp-dashboard-Leave-Requests-main-container">
                <div className="emp-dashboard-Leave-outter">
                  <div className="emp-dashboard-card-header">
                    <div>
                      <p className="Leave-heading">Leave Requests</p>
                    </div>
                  </div>
                  <div className="emp-dashboard-table-container">
                    <table className="table-of-employee-leaves">
                      <thead className="thead-of-emp-table-leaves">
                        <tr className="">
                          <th className="hr-dashboard-no">Sr. No.</th>
                          {/* <th className="">Name</th> */}
                          <th className="hr-dashboard-date"> Date</th>
                          <th className="hr-dashboard-type">Leave Type</th>
                          <th className="hr-dashboard-from">Leave From</th>
                          <th className="hr-dashboard-to">Leave To</th>
                          <th className="hr-dashboard-days">No Of Days</th>
                          <th className="hr-dashboard-Status">Status</th>
                          <th className="hr-dashboard-Action">Action</th>
                        </tr>
                      </thead>
                      <tbody className="tbody-ofemp-table-leaves">
                        {leaveRequest?.length ? (
                          <>
                            {leaveRequest?.map((item, index) => (
                              <tr key={index}>
                                <>
                                  <td>{index + 1}</td>
                                  {/* <td>{item?.User?.UserName}</td> */}
                                  <td>
                                    {/* {item?.AppliedDate} */}
                                    {moment(item?.AppliedDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td>
                                    {/* {item?.LeaveType === 0
                                      ? "Casual Leave"
                                      : item?.LeaveType === 1
                                        ? "Sick Leave"  
                                        : ""} */}
                                    {item?.LeaveTypes?.Name}
                                  </td>
                                  {/* <td>{item?.StartDate.split("T")[0]}</td> */}
                                  <td>
                                    {moment(item?.StartDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td>
                                    {moment(item?.EndDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td>{item?.NumberofDays}</td>
                                  <td>
                                    {/* <button
                                      className={
                                        item?.Status === "Cancelled"
                                          ? "EMP-Leaves-table-Pending-button"
                                          : item?.Status ===
                                              "RejectedByTeamLead" ||
                                            item?.Status === "RejectedByHR" ||
                                            item?.Status === "RejectedByAdmin"
                                          ? "EMP-Leaves-table-Rejected-button"
                                          : item?.Status === "ApprovedByHR" ||
                                            item?.Status ===
                                              "ApprovedByTeamLead"
                                          ? "EMP-YetToBeApprovedByTeamLead-button"
                                          : item?.Status ===
                                            "YetToBeApprovedByTeamLead"
                                          ? "EMP-YetToBeApprovedByTeamLead-button"
                                          : item?.Status ===
                                              "YetToBeApprovedByAdmin" ||
                                            item?.Status ===
                                              "YetToBeApprovedByHR"
                                          ? "EMP-YetToBeApprovedByTeamLead-button"
                                          : "EMP-Leaves-table-Approved-button"
                                      }
                                    >
                                      {item?.Status ===
                                      "YetToBeApprovedByTeamLead"
                                        ? "Pending at Team Lead"
                                        : item?.Status === "RejectedByTeamLead"
                                        ? "Rejected by Team Lead"
                                        : item?.Status === "RejectedByHR"
                                        ? "Rejected by HR"
                                        : item?.Status === "ApprovedByTeamLead"
                                        ? "Pending at HR"
                                        : item?.Status === "ApprovedByHR"
                                        ? "Pending at Admin"
                                        : item?.Status === "ApprovedByAdmin"
                                        ? "Approved by Admin"
                                        : item?.Status === "RejectedByAdmin"
                                        ? "Rejected by Admin"
                                        : item?.Status === "YetToBeApprovedByHR"
                                        ? "Pending at HR"
                                        : item?.Status ===
                                          "YetToBeApprovedByAdmin"
                                        ? "Pending At Admin"
                                        : item?.Status === "Cancelled"
                                        ? "Cancelled by user"
                                        : item?.Status}
                                    </button> */}
                                          {/* <button className={
              // red color for Cancelled and  Rejected leaves
              item?.Status === "Cancelled" ||
              item?.Status === "Rejected By TeamLead" ||
              item?.Status === "Rejected By HR" ||
              item?.Status === "Rejected By Admin"
               ? "EMP-Leaves-approval-table-Rejected-button"
              //  blue color  for the Approved
                : item?.Status === "ApprovedByTeamLead" ||
                  item?.Status === "YetToBeApprovedByTeamLead" ||
                  item?.Status === "ApprovedByHR" ||
                  item?.Status === "Pending At HR" ||
                  item?.Status === "Pending At Admin" || item?.Status === "Approved By Admin"
                 ? "EMP-YetToBeApprovedByTeamLead-button-Approval"
                  : "EMP-Leaves-table-Approved-button"
            }>
            {item.Status}
            </button> */}

             <button className={
              // red color for Cancelled and  Rejected leaves
              item?.Status === "Cancelled" ||
              item?.Status === "Rejected By Team Lead" ||
              item?.Status === "Rejected By HR" ||
              item?.Status === "Rejected By Admin"
               ? "EMP-Leaves-approval-table-Rejected-button"
              //  blue color  for the Approved
                : item?.Status === "ApprovedByTeamLead" ||
                  item?.Status === "YetToBeApprovedByTeamLead" ||
                  item?.Status === "ApprovedByHR" ||
                  item?.Status === "YetToBeApprovedByHR" ||
                  item?.Status === "YetToBeApprovedByAdmin" || item?.Status === "Approved By Admin"
                 ? "EMP-YetToBeApprovedByTeamLead-button-Approval"
                  : "EMP-Leaves-table-Approved-button"
            }>
            {item.Status}
            </button>
                                  </td>
                                 
                                    <td className="">
                                      <button
                                        onClick={() =>
                                          navigate("/Emp/EMPLeaves")
                                        }
                                        className="EMP-Approve-table-Approved-button-dashboard"
                                      >
                                        Details
                                      </button>
                                    </td>
                                  {/* )} */}
                                </>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <>
                            <tr className="no-record-found-tr-dashboard">
                              <td colSpan="10">No record found</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Notice Board */}
              <div className="emp-dashboard-notice-board-main-container">
                <div>
                  <p className="Notice-heading">Notice Board</p>
                </div>
                <div className="emp-dashboard-scroll">
                  <div>
                    <div>
                      {Announceentdata
                        ?.sort((a, b) => new Date(b.FlashTillDate) - new Date(a.FlashTillDate))
                        ?.map((item, index) => (
                        
                        <div key={index}>
                          {item?.AnnouncementTitle ||
                          item?.Description ||
                          item?.FlashTillDate ? (
                            <div className="emp-dashboard-notice-board-inner">
                              <img
                                className="emp-dashboard-user-img"
                                src={userimg}
                                alt=""
                              />
                              <div>
                                <p className="emp-dashboard-notice-board-heading">
                                  {item?.AnnouncementTitle}
                                </p>
                                <p className="emp-dashboard-lorem">
                                  {item?.Description}
                                </p>
                                {item?.FlashTillDate ? (
                                  <p className="emp-dashboard-time">
                                    {moment(item?.FlashTillDate).format(
                                      "DD MMMM YYYY"
                                    )}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table">
        <NewEmployeesModal className="modal-main-inner-container"/>
      </Modal>
      {showModalNew && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={handleCloseModal}
            >
              <Modal.Title>Cancel Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="">Reason</label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  value={deleteLeave?.IdDelete}
                  onChange={(e) =>
                    setDeleteLeave({
                      ...deleteLeave,
                      IdDelete: e?.target?.value,
                    })
                  }
                />
                {errorLeaveType === "userLeaveType" &&
                !deleteLeave?.IdDelete ? (
                  <span className="reason-delete-leave">
                    Reason is required.
                  </span>
                ) : null}
              </div>
            </Modal.Body>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={handleCloseModal}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={(e) => handleDeleteLeave(e)}
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};
export default EmpDashboard;
